<div ngClass="p-t-l p-r-l">
	<button mat-icon-button class="close-button" (click)="onNoClick()">
		<img
			src="https://whydonate.com/cdn-cgi/imagedelivery/_0vgnXOEIHPwLg2E52a7gg/shared/crossBlack/public"
		/>
	</button>
</div>
<div ngClass="m-l-xl">
	<h2 i18n="@@edit_About_fundraiser_title">Edit Fundraiser Title</h2>
</div>
<mat-dialog-content class="mat-typography">
	<!-- <h3>Describe About fundraiser</h3> -->
	<div ngClass="m-l-xs" fxLayout="row" fxLayoutAlign="start center">
		<mat-label class="mat-subtitle-2" i18n="@@edit_update_originalLanguage_title"
			>Original Language</mat-label
		>
		<div fxLayout="row" ngClass="p-xs" fxLayoutAlign="start center">
			<img
				width="20px"
				src="{{ languageIconPath + originalLocale + '1/public' }}"
			/>&nbsp;
			<span>{{ allLanguages[originalLocale] }}</span>
		</div>
	</div>
	<br />
	<div ngClass="m-l-xs m-r-xs">
		<!-- <mat-label i18n="@@editAbout_fundraiser_title">Fundraiser Title</mat-label> -->
		<form [formGroup]="titleFormGroup">
			<mat-form-field class="w-100" appearance="outline">
				<input
					id="fundraiserTitle"
					matInput
					formControlName="translationTitle"
					(ngModelChange)="onTitleChange($event)"
					#titleedit
				/>
				<mat-hint align="end"
					>{{ titleedit.value.length }} / 5-75
					<span i18n="@@characters_translation">Characters</span>
				</mat-hint>
				<mat-error
					i18n="@@createFundraiser_error"
					*ngIf="
						titleFormGroup.controls['translationTitle'].errors &&
						titleFormGroup.controls['translationTitle'].errors.pattern
					"
				>
					Wrong title. You can only use letters and numbers.
				</mat-error>
				<mat-error
					i18n="@@createFundraiser_mustBeBetween_error"
					*ngIf="
						titleFormGroup.controls['translationTitle'].errors &&
						(titleFormGroup.controls['translationTitle'].errors.minlength ||
							titleFormGroup.controls['translationTitle'].errors.maxlength)
					"
				>
					Must be between 5 - 75 characters
				</mat-error>
			</mat-form-field>
		</form>
	</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button
		id="editAboutDiscard"
		mat-button
		color="accent"
		(click)="discardChanges()"
		[disabled]="
			!(newAbout?.content || newAbout?.imageList || titleFormGroup.dirty) ||
			isSave
		"
		i18n="@@button_discard"
	>
		Discard
	</button>
	<button
		id="editAboutSaveButton"
		mat-flat-button
		color="accent"
		[disabled]="
			!(newAbout?.content || newAbout?.imageList || titleFormGroup.dirty) ||
			isSave ||
			this.maxLengthCheck ||
			titleFormGroup.invalid
		"
		(click)="saveAboutContentAndMedia()"
	>
		<span i18n="@@button_save">Save</span>
		<mat-icon *ngIf="isSave" ngClass="m-l-xs">
			<mat-spinner color="accent" diameter="16" i18n="@@editAbout_spinner">
			</mat-spinner>
		</mat-icon>
	</button>
</mat-dialog-actions>

<!-- <mat-label class="m-l-xs" i18n="@@edit_about_aboutFundraiser_label"
	>About Fundraiser</mat-label
>
<app-quill-editor
	[quillContent]="data.currentFundraiser.content"
	(onContentChange)="changeAboutContent($event)"
	[control]="quillContentCtrl"
	(maxLengthBoolean)="checkBoolean($event)"
></app-quill-editor>
<br />
<div
	class="m-l-xs"
	fxLayout="row wrap"
	fxLayoutAlign="start center"
	fxLayoutGap="16px"
>
	<app-fundraiser-media-edit
		[fundraiserMediaList]="mediaList"
		[resetControl]="mediaResetControl"
		(onMediaChange)="changeAboutMedia($event)"
	>
	</app-fundraiser-media-edit>
</div> -->
